export class Controller {
	static $isController = true;

	title = null;
	description = null;
	keywords = null;
	image = null;
	css = null;
	data = {};

	constructor(data = {}) {
		this.data = data;
	}

	middleware() {

	}
}

export default Controller;
